import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import ListItem from '@mui/material/ListItem';

const Component = () => {
    return (
        <ListItem className="subusers__item" component="li">
            <Skeleton className="subusers__skeleton" />
        </ListItem>
    );
};

const ListSkeletonComponent = React.memo(Component);

export default ListSkeletonComponent;
